import { render, staticRenderFns } from "./TypingTutorWidget.vue?vue&type=template&id=7f9d83b0"
import script from "./TypingTutorWidget.vue?vue&type=script&lang=js"
export * from "./TypingTutorWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports